/* Baresoul — cart free-shipping bar (cart page only) + combo callout + Shop by Vibe tiles + View-all CTA (Claude) */
(function(){
  'use strict';
  var THRESHOLD=59900;
  if(!document.getElementById('bs-fsbar-style')){
    var st=document.createElement('style');
    st.id='bs-fsbar-style';
    st.textContent='.bs-fsbar{margin:0 0 18px;padding:14px 16px;border:1px solid rgba(200,169,110,0.18);border-radius:10px;background:rgba(200,169,110,0.05);}'
      +'.bs-fsbar__msg{font-size:13px;letter-spacing:.02em;color:#C8A96E;font-weight:600;margin:0 0 9px;line-height:1.4;}'
      +'.bs-fsbar__msg b{color:#EDE5D8;font-weight:700;}'
      +'.bs-fsbar__track{height:7px;border-radius:6px;background:rgba(255,255,255,0.08);overflow:hidden;}'
      +'.bs-fsbar__fill{height:100%;width:0;border-radius:6px;background:linear-gradient(90deg,#C8A96E,#DFC08A);transition:width .5s cubic-bezier(.4,0,.2,1);}'
      +'.bs-fsbar--done{background:rgba(60,160,90,0.08);border-color:rgba(80,190,120,0.35);}'
      +'.bs-fsbar--done .bs-fsbar__msg{color:#7fd99a;}'
      +'.bs-fsbar--done .bs-fsbar__fill{background:linear-gradient(90deg,#3ca05a,#7fd99a);}'
      +'.bs-combo-note{margin:14px 0 0;padding:11px 14px;border:1px dashed rgba(200,169,110,0.4);border-radius:8px;background:rgba(200,169,110,0.05);color:#D4C9B8;font-size:13px;line-height:1.5;}'
      +'.bs-combo-note b{color:#EDE5D8;}'
      +'.bs-combo-note__tag{display:inline-block;background:#C8A96E;color:#0A0A0A;font-size:10px;font-weight:700;letter-spacing:.1em;padding:2px 7px;border-radius:3px;margin-right:8px;vertical-align:middle;}'
      +'.bs-combo-note__sub{color:#9b8f7d;}'
      +'@media(max-width:749px){.bs-fsbar{margin-bottom:14px;padding:12px 14px;}.bs-fsbar__msg{font-size:12.5px;}}';
    document.head.appendChild(st);
  }
  function fmt(p){return '₹'+Math.ceil(p/100).toLocaleString('en-IN');}

  /* Free-shipping bar targets the CART PAGE ONLY — never the cart drawer,
     so it can never interfere with the drawer / checkout button. */
  function anchors(){
    var list=[];
    var drawer=document.querySelector('cart-drawer-component, cart-drawer, [class*=cart-drawer]');
    var items=document.querySelectorAll('cart-items-component, .cart-items, #main-cart-items');
    var pageItems=null;
    items.forEach(function(el){ if(!(drawer&&drawer.contains(el))){ if(!pageItems) pageItems=el; } });
    if(pageItems){ var sec=pageItems.closest('.shopify-section')||pageItems.parentElement; if(sec) list.push(sec); }
    return list;
  }
  function render(cart){
    var total=cart.total_price;
    var remaining=THRESHOLD-total;
    var done=remaining<=0;
    var pct=Math.max(0,Math.min(100,Math.round(total/THRESHOLD*100)));
    var seen=anchors();
    if(!seen.length) return;
    document.querySelectorAll('.bs-fsbar').forEach(function(b){ if(seen.indexOf(b.parentElement)===-1) b.remove(); });
    seen.forEach(function(a){
      var ex=a.querySelector(':scope > .bs-fsbar');
      if(!total){ if(ex) ex.remove(); return; }
      var bar=ex;
      if(!bar){ bar=document.createElement('div'); a.insertBefore(bar,a.firstChild); }
      bar.className='bs-fsbar'+(done?' bs-fsbar--done':'');
      var msg=document.createElement('p'); msg.className='bs-fsbar__msg';
      msg.innerHTML=done?'🎉 You’ve unlocked <b>FREE shipping!</b>':'🚚 You’re <b>'+fmt(remaining)+'</b> away from <b>FREE shipping</b>';
      var track=document.createElement('div'); track.className='bs-fsbar__track';
      var fill=document.createElement('div'); fill.className='bs-fsbar__fill'; fill.style.width=(done?100:pct)+'%';
      track.appendChild(fill);
      bar.innerHTML=''; bar.appendChild(msg); bar.appendChild(track);
    });
  }
  var busy=false;
  function refresh(){ if(location.pathname.indexOf('/cart')===-1) return; if(busy)return; busy=true; window.fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){busy=false;render(c);}).catch(function(){busy=false;}); }

  function initCombo(){
    if(location.pathname.indexOf('/products/')===-1) return;
    if(document.getElementById('bs-combo-note')) return;
    var form=null;
    var ab=document.querySelector('[name=add]'); if(ab) form=ab.closest('form');
    if(!form){ var fs=document.querySelectorAll('form'); for(var i=0;i<fs.length;i++){ if((fs[i].getAttribute('action')||'').indexOf('/cart')>-1){form=fs[i];break;} } }
    if(!form) return;
    var note=document.createElement('div');
    note.id='bs-combo-note'; note.className='bs-combo-note';
    note.innerHTML='<span class=bs-combo-note__tag>COMBO</span>Buy <b>2 tees</b> and get <b>20% off</b> — auto-applied at checkout. <span class=bs-combo-note__sub>Free shipping over ₹599.</span>';
    form.parentNode.insertBefore(note, form.nextSibling);
  }

  function homepageSection(){ var el=document.querySelector('[class*=ai-infinite-collection-]'); return el?(el.closest('.shopify-section')||el):null; }
  function isHome(){ var p=location.pathname; return p==='/'||p===''; }

  function initVibes(){
    if(!isHome()) return;
    if(document.getElementById('bs-vibes')) return;
    var sec=homepageSection(); if(!sec) return;
    var V=[
      ['Desi Mood','/collections/desi-mood','https://cdn.shopify.com/s/files/1/0953/6317/0584/files/1781441493216-6c6710f2-b222-4c37-931d-8cd0762ebe88-1d3488b64912481b99a75f70855a6274-flat-black.png'],
      ['Main Character Energy','/collections/main-character-energy','https://cdn.shopify.com/s/files/1/0953/6317/0584/files/1781516256560-5db2b8c4-847a-4a5c-a1c5-0f35fdc5409f-300b7746d6a34edfb1be577b70dcc6ee-flat-yellow.png'],
      ['Y2K & Retro','/collections/y2k-retro','https://cdn.shopify.com/s/files/1/0953/6317/0584/files/1781802371909-70b343c6-11a1-4770-b6c5-6236824a6d8d-dac36df8415f48beaf7f157a4efb9de9-flat-black.png'],
      ['Cosmic & Astrology','/collections/cosmic-astrology','https://cdn.shopify.com/s/files/1/0953/6317/0584/files/1781730296015-72bf09d3-3fc7-4158-a33b-0e1b86896d5a-1c20acb7f9794f42900730a817a70110-flat-black.png'],
      ['Nerd Club','/collections/nerd-club-1','https://cdn.shopify.com/s/files/1/0953/6317/0584/files/whimsical-talk-nerdy-to-me-design_white.png'],
      ['Gym & Wander','/collections/gym-wander','https://cdn.shopify.com/s/files/1/0953/6317/0584/files/vibrant-gym-humor-t-shirt-design_white.png']
    ];
    var wrap=document.createElement('div'); wrap.id='bs-vibes'; wrap.className='bs-vibes';
    var h=document.createElement('h2'); h.className='bs-vibes__title'; h.textContent='Shop by Vibe'; wrap.appendChild(h);
    var grid=document.createElement('div'); grid.className='bs-vibes__grid';
    V.forEach(function(v){
      var a=document.createElement('a'); a.className='bs-vibes__tile'; a.href=v[1];
      var im=document.createElement('div'); im.className='bs-vibes__img';
      var img=document.createElement('img'); img.src=v[2]+'?width=500'; img.alt=v[0]; img.loading='lazy'; img.width=500; img.height=500;
      im.appendChild(img); a.appendChild(im);
      var s=document.createElement('span'); s.className='bs-vibes__label'; s.textContent=v[0]; a.appendChild(s);
      grid.appendChild(a);
    });
    wrap.appendChild(grid);
    sec.parentNode.insertBefore(wrap, sec);
  }

  function initViewAll(){
    if(!isHome()) return;
    if(document.getElementById('bs-viewall')) return;
    var sec=homepageSection(); if(!sec) return;
    var wrap=document.createElement('div'); wrap.id='bs-viewall'; wrap.className='bs-viewall';
    var a=document.createElement('a'); a.className='bs-viewall__btn'; a.href='/collections/all'; a.textContent='View all tees →';
    wrap.appendChild(a);
    sec.parentNode.insertBefore(wrap, sec.nextSibling);
  }

  /* wiring: no fetch override, no drawer manipulation. */
  ['cart:refresh','cart:updated','cart:change'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(refresh,200);});});
  var mo=new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ var an=muts[i].addedNodes; for(var j=0;j<an.length;j++){ var n=an[j]; if(n.nodeType!==1)continue; var cn=(n.className||'')+''; if(cn.indexOf('ai-infinite-collection-')>-1||(n.querySelector&&n.querySelector('[class*=ai-infinite-collection-]'))){ initVibes(); initViewAll(); } } } });
  mo.observe(document.documentElement,{childList:true,subtree:true});
  function start(){ refresh(); initCombo(); initVibes(); initViewAll(); setTimeout(function(){initCombo();initVibes();initViewAll();},1200); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
